var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "rounded-0 h-100" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: this.$t("message.adminUserDetail.legitimation")
                      }
                    },
                    [
                      _c("b-form-radio-group", {
                        attrs: {
                          disabled: !_vm.userIsPolicyHolder,
                          buttons: "",
                          "button-variant": "outline-primary",
                          options: _vm.legiOptions
                        },
                        model: {
                          value: _vm.legiSelected,
                          callback: function($$v) {
                            _vm.legiSelected = $$v
                          },
                          expression: "legiSelected"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "w-75" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: this.$t("message.adminUserDetail.status"),
                        state: _vm.$v.newDateOfDeath.$error ? false : null,
                        "invalid-feedback": _vm.$t(
                          "error.personalInformationForm.dateOfBirth"
                        )
                      }
                    },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c("b-form-radio-group", {
                            staticClass: "input-group-btn",
                            attrs: {
                              buttons: "",
                              "button-variant": "outline-primary",
                              options: _vm.doaOptions
                            },
                            model: {
                              value: _vm.aliveSelected,
                              callback: function($$v) {
                                _vm.aliveSelected = $$v
                              },
                              expression: "aliveSelected"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticClass: "rounded-0 text-right",
                            attrs: {
                              disabled:
                                _vm.aliveSelected2 || !!_vm.user.dateOfDeath,
                              id: "dateOfBirth",
                              placeholder: "TT.MM.JJJJ",
                              state: _vm.$v.newDateOfDeath.$error ? false : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.newDateOfDeath.$touch()
                              }
                            },
                            model: {
                              value: _vm.dateOfDeathField,
                              callback: function($$v) {
                                _vm.dateOfDeathField = $$v
                              },
                              expression: "dateOfDeathField"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.submitStatus }
                    },
                    [
                      _c("span", { staticClass: "ti-save mr-2" }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.adminUserDetail.save")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3446cb8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3446cb8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminUserStatus.vue
// module id = gf5p
// module chunks = 1